<template>
  <div>
    <b-card>
      <div slot="header">
        {{ title }}
      </div>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="`${$lang.report_setting_type}: `"
              :rules="$v.report_settings_selected.$params"
            />
            <selectFind
              :options="report_settings_options"
              v-model="$v.report_settings_selected.$model"
              label="caption"
              :isValid="
                $v.report_settings_selected.$dirty
                  ? !$v.report_settings_selected.$error
                  : null
              "
              :loading="report_settings_loading"
            />
            <b-form-invalid-feedback
              :state="
                $v.report_settings_selected.$dirty
                  ? !$v.report_settings_selected.$error
                  : null
              "
            >
              <div v-if="!$v.report_settings_selected.required">
                {{ $lang.error_required | replace($lang.report_setting_type) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <ShowCardUpload
        :url="uploadExcelUrl"
        :hasAppendData="true"
        acceptFormatsInput=""
        :acceptFormats="acceptFormats"
        :appendData="appendData"
        :isValidAppendData="isValidAppendData"
        @getItems="getItems"
        @submit="submit"
        @closeModal="close"
      />
    </b-card>
  </div>
</template>

<script>
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: { ShowCardUpload },
  validations: {
    report_settings_selected: { required },
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    resource: {
      type: String,
      default: null,
    },
    resourceCode: {
      type: [String, Number],
      default: null,
    },
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
    acceptFormats: {
      type: Array,
      default: () => [
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
      ],
    },
  },
  data() {
    return {
      report_settings_selected: null,
      report_settings_options: [],
      report_settings_loading: false,
    };
  },
  computed: {
    uploadExcelUrl() {
      return generateApiUrl(
        ["resources", "report_resource"],
        [this.resource, this.resourceCode]
      );
    },
    appendData() {
      return {
        parvandeh_code: this.parvandehCode,
        report_setting_id: pathOr(null, ["id"], this.report_settings_selected),
      };
    },
    isValidAppendData() {
      return !!(this.parvandehCode && this.report_settings_selected);
    },
  },
  created() {
    this.getReportSettingCombo();
  },
  methods: {
    pathOr,
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    getItems() {
      this.$emit("getItems");
    },
    async getReportSettingCombo() {
      try {
        this.report_settings_loading = true;
        const url = generateApiUrl(["resources", "report_settings_combo"], [], {
          is_manual: 1,
          resource: this.resource,
        });
        const response = await this.$httpService.get(url);
        this.report_settings_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.report_settings_loading = false;
      }
    },
    submit() {
      this.$v.$touch();
    },
  },
};
</script>
